// extracted by mini-css-extract-plugin
export default {"form":"NewAccount_form__+iETp"};